import { AuthCalendlyResponseData } from 'types'
import { StorageService } from 'utils'

export const useCalendlyAuthData = () => {
  return StorageService.read('calendlyAuth') as
    | AuthCalendlyResponseData
    | undefined
    | null
}
